import { Mail, Phone, MapPin } from "lucide-react";
import { BRAND, CONTACT, NAV_LINKS } from "../data/mock";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-950 text-slate-300 pt-16 pb-8 relative overflow-hidden"
    >
      <div className="absolute -top-20 right-0 h-72 w-72 rounded-full bg-orange-500/10 blur-3xl" />
      <div className="absolute -bottom-20 left-0 h-72 w-72 rounded-full bg-teal-500/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center">
              <img
                  src={BRAND.whiteLogoUrl}
                  alt="Reptile Hisabbook"
                  className="h-12 w-auto object-contain"
              />
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-md">
              Go Paperless. Go Digital. Go Reptile Hisabbook. India's smart credit,
              invoice and inventory app for small & growing businesses.
            </p>
          </div>

          {/* Quick links */}
          <div className="md:col-span-3">
            <h4 className="font-heading text-white font-semibold mb-4 text-sm uppercase tracking-[0.18em]">
              Quick links
            </h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="text-sm text-slate-400 hover:text-orange-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="font-heading text-white font-semibold mb-4 text-sm uppercase tracking-[0.18em]">
              Contact
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-1 text-orange-400 shrink-0" />
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="text-slate-300 hover:text-white transition-colors break-all"
                  data-testid="footer-email"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 mt-1 text-teal-400 shrink-0" />
                <a
                  href={`tel:${CONTACT.phoneRaw}`}
                  className="text-slate-300 hover:text-white transition-colors"
                  data-testid="footer-phone"
                >
                  +91 {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-1 text-emerald-400 shrink-0" />
                <span className="text-slate-400 leading-relaxed" data-testid="footer-address">
                  {CONTACT.address}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Tagline strip */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">

          <div className="font-heading text-xl md:text-2xl text-white tracking-tight text-center md:text-left">
            Go Paperless.{" "}
            <span className="text-teal-400">
      Go Digital.
    </span>{" "}
            <span className="text-orange-400">
      Go Reptile Hisabbook.
    </span>
          </div>

          <div className="text-center md:text-right">

            <p
                data-testid="copyright"
                className="text-xs text-slate-500"
            >
              © {new Date().getFullYear()} Reptile Hisabbook App.
              All rights reserved.
            </p>

            <p className="text-[11px] text-slate-400 mt-1">
              Powered by{" "}
              <span className="text-teal-400 font-medium">
        Carecone Technologies Pvt Ltd
      </span>
            </p>

          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
